export default __webpack_public_path__ + "static/media/parts.27cd764a.PNG";